module.exports = __webpack_public_path__ + "img/share1.3099313a.png";